import React, { useCallback } from 'react';

import PartialCTA from './partials/cta';
import { useViewport } from '~/utils/viewport-provider';
import { getManualPositioning } from '~/utils/helpers';

interface CtaBannerProps {
  block: {
    _template: string;
    css_class_name: string;
    image: string;
    image_alt_text: string;
    title: string;
    subtitle: string;
    cta_field: {
      cta_link: string;
      cta_text: string;
    };
    manual_positioning: ManualPositioning;
  };
}

const CtaBanner: React.FC<CtaBannerProps> = ({ block }) => {
  const { isMobile } = useViewport();
  const { manual_positioning } = block;
  let { mobile, desktop } = getManualPositioning(manual_positioning);

  return (
    <section className={`block__cta_banner block ${block.css_class_name}`}>
      <div className='container'>
        <div className='banner-wr'>
          <div className='content'>
            {block.image && (
              <img
                src={block.image}
                alt={block.image_alt_text}
                title={block.image_alt_text}
                style={isMobile ? mobile : desktop}
                className='min-w-[50px]'
              />
            )}
            <div className='content-wr'>
              {block.title && (
                <h4 dangerouslySetInnerHTML={{ __html: block.title }}></h4>
              )}
              {block.subtitle && (
                <p dangerouslySetInnerHTML={{ __html: block.subtitle }}></p>
              )}
            </div>
          </div>

          {block.cta_field && <PartialCTA data={block.cta_field} />}
        </div>
      </div>
    </section>
  );
};
export default CtaBanner;
